import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from '../../axios-default';
import { WinStatus } from '../../model/oauth/medictLink_type';

/**
 * Window status values.
 * @type {WinStatus}
 */
export const WIN_STATUS = {
    OPEN: 'OPEN',
    CLOSE: 'CLOSE',
};

/**
 * Initial state object.
 * @type {ConnectedPlaformState}
 */
const initialState = {
    isLoading: false,
    data: [],
    isError: false,
    oauthWindowStatus: WIN_STATUS.CLOSE,
};

// Define the asynchronous action
export const fetchConnectPlatformData = createAsyncThunk(
    'fetchConnectedPlatformInfo',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get(`/connectPlatform/check_connect`);
            if (!response.data.success) {
                return rejectWithValue('Failed to fetch data');
            }
            const data = response.data.message;
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const connectPlatformSlice = createSlice({
    name: 'connectPlatform',
    initialState: initialState,
    reducers: {
        openWin: (state) => {
            state.oauthWindowStatus = WIN_STATUS.OPEN;
        },
        closeWin: (state) => {
            state.oauthWindowStatus = WIN_STATUS.CLOSE;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchConnectPlatformData.pending, (state) => {
                state.isLoading = true;
                state.isError = false;
            })
            .addCase(fetchConnectPlatformData.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
                state.isError = false;
            })
            .addCase(fetchConnectPlatformData.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.data = [];
            });
    },
});

export const getConnectPlatformList = (state) => {
    return {
        isLoading: state.connectPlatform.isLoading,
        isError: state.connectPlatform.isError,
        data: state.connectPlatform.data,
    };
};

export const { openWin, closeWin } = connectPlatformSlice.actions;

export const connectPlatformReducer = connectPlatformSlice.reducer;
